<main
  class="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto overflow-x-hidden"
>
  <div
    data-cid="main-content"
    class="flex min-w-0 flex-1 flex-col"
    [class.min-h-full]="fullBleed()"
    [class.min-h-0]="fixedHeight()"
    [class.px-4]="!fullBleed()"
    [class.pb-8]="!fullBleed()"
    [class.max-sm:pb-24]="!fullBleed()"
    [class.lg:px-6]="!fullBleed()"
    [class.full-bleed]="fullBleed()"
  >
    <router-outlet />
  </div>
</main>
